module.exports = __webpack_public_path__ + "img/credit-card.9dd1a79a.svg";